import classnames from 'classnames';
import React, { useState } from 'react';

import { EMTPY_LIST_ITEMS } from '@common/constants';
import { noop } from '@utils';

interface ItemProps {
	id?: string;
	onClick?: (any) => void;
}

const flex = 'flex flex-row justify-between items-center';

const ListMenu = ({
	items = EMTPY_LIST_ITEMS,
	renderer,
	onClick = noop,
	className,
	activeOptions = true,
}: {
	className?: string;
	onClick: (any) => void;
	renderer;
	items: ItemProps[];
	activeOptions?: boolean;
}) => {
	const [selectedIndex, setSelectedIndex] = useState(null);

	return (
		<div
			className={classnames(
				className,
				'flex flex-col overflow-hidden rounded-md border border-common-dark bg-secondary-dark pb-1 pt-1',
			)}
		>
			{items.map((item, index) => {
				const isSelected = selectedIndex === index;
				const onClickHandler = () => {
					if (activeOptions) {
						setSelectedIndex(index);
					}
					onClick({ item, selectedIndex: index });
					item.onClick?.({ ...item, index, isSelected });
				};

				return (
					<div
						role="button"
						tabIndex={index}
						key={`ListItem${item.id || index}`}
						className={classnames(flex, 'cursor-pointer bg-primary-main text-common-bright', index !== items.length - 1 && '')}
						onClick={onClickHandler}
						data-cy={item.id}
					>
						{renderer && renderer({ ...item, index, isSelected })}
					</div>
				);
			})}
		</div>
	);
};

export default ListMenu;
